import { ReactNode, useCallback } from 'react'
import { useDropzone } from 'react-dropzone'
import { cn } from '@global/utils/tailwind'
import * as css from './styles'

interface IDragNDrop {
  children: ReactNode
  onDrop: (files: File[]) => void
}

export const DragNDrop = ({ children, onDrop }: IDragNDrop) => {
  const onDropCallback = useCallback(acceptedFiles => {
    onDrop(acceptedFiles)
  }, [])

  const { getRootProps, isDragActive } = useDropzone({
    onDrop: onDropCallback,
  })

  const dropClasses = cn({
    'clvn__drag-n-drop-container': true,
    '-is-dragging-over': isDragActive,
  })

  return (
    <css.BorderContainer {...getRootProps({ className: dropClasses })}>
      {children}
    </css.BorderContainer>
  )
}
